module.exports = __webpack_public_path__ + "static/media/Oval-red-icon.3ab4bfce.svg";